<template>
	<div class='page'>
    <pageTitle title='商城预存款兑换' />

    <div class="content">
      <table>
        <thead>
          <tr>
            <td>可提项目</td>
            <td>可兑换数量</td>
            <td>兑换数量</td>
            <td>兑换率</td>
          </tr>
        </thead>
                <tbody>
                    <tr>
                        <td>银联现金券<small>（元）</small></td>
                        <td>{{limit.UnionMoneyRemian}}</td>
                        <td><input v-model='vcash' type='number' placeholder='输入整数'/></td>
                        <td>1:1</td>
                    </tr>
                    <tr>
                        <td>现金券<small>（元）</small></td>
                        <td>{{limit.ExpMoneyRemian}}</td>
                        <td><input v-model='cash' type='number' placeholder='输入整数'/></td>
                        <td>1:1</td>
                    </tr>
                    <tr>
                        <td>K币<small>（个）</small></td>
                        <td>{{limit.GreenTreeCoin}}</td>
                        <td><input v-model='kicon' type='number' placeholder='输入整数'/></td>
                        <td>100:1</td>
                    </tr>
                    <tr>
                        <td>储值卡<small>（元）</small><br/><small>消费开票账户</small></td>
                        <td>{{limit.Storage}}</td>
                        <td><input v-model='consume' type='number' placeholder='输入整数'/></td>
                        <td>1:1</td>
                    </tr>
                    <tr>
                        <td>储值卡<small>（元）</small><br/><small>充值开票账户</small></td>
                        <td>{{limit.InvoiceStorage}}</td>
                        <td><input  v-model='recharge' type='number' placeholder='输入整数'/></td>
                        <td>1:1</td>
                    </tr>
                </tbody>
                <tfoot>
                </tfoot>
                    <tr>
                        <td colspan="4" style="background-color:white;padding:20px;color:black;font-size:0.34rem;">转换合计&nbsp;{{all}}元</td>
                    </tr>
                </table>
        </div>
        <div class='vCardPwd' v-if='consume > 0 || recharge > 0'>
            <mu-icon value="lock" color="#666666" style='position:relative;margin:auto 0;border-right:1px solid #e4e4e4;padding-right:20px;'/>
            <mu-text-field type='password' v-model='vPwd' :underlineShow='false' hintText="请输入储值卡密码"/>
        </div>
        <div class='foot' style='padding:0 15px;margin-top:0.3rem'>
            <mu-raised-button label="确定兑换" primary  v-bind:style="{ width:'100%',height:'50px'}" v-on:click="exchange"/>
            <p><small style="color:#999999">*兑换成功后不能取消</small></p>
        </div>
        <mu-toast id="alertline" style="height:auto;width:90%;margin:0 5% 65vh 5%;word-wrap:break-word;white-space:normal" v-if="toast" v-html="TellUser" @close="hideToast"/>
  </div>
</template>


<style lang="less" scoped>
@import "../../assets/theme.less";
.content {
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      border-bottom: 1px solid #f1f1f1;
      td {
        border: none;
        margin: auto;
        text-align: center;
        input {
          width: 75px;
          border: none;
          text-align: left;
          margin-right: -20px;
        }
        input:focus {
          outline: medium;
        }
      }
    }
    thead {
      background-color: #fefefe;
      tr {
        td {
          text-align: left;
          font-size: 0.3rem;
          color: @textColor;
          padding: 15px 10px 12px 10px;
          font-weight: 400;
        }
      }
    }
    tbody {
      padding: 0;
      tr {
        td {
          background-color: white;
          padding: 15px 12px;
          text-align: right;
        }
        td:first-child {
          text-align: left;
          color: @primaryColor;
          font-size: 0.3rem;
          small {
            color: @primaryColor;
            position: relative;
            top: -1px;
          }
        }
        td:nth-child(2),td:last-child {
          color: black;
          font-size: 0.3rem;
        }
      }
    }
  }
}
.vCardPwd {
  height: 1rem;
  background-color: white;
  margin-top: 0.3rem;
  padding-left: 15px;
  border-top: 1px solid #e4e4e4;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
}
</style>

<style lang='less'>
.vCardPwd {
  .mu-text-field {
    display: flex;
    .mu-text-field-content {
      margin: auto 20px;
      padding: 0.14rem 0;
      font-size: 0.3rem;
      display: flex;
      .mu-text-field-hint {
        margin: auto 0;
      }
    }
  }
}
</style>
<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import {} from "../../utils/valid.js";
import pageTitle from "../../components/pageTitle.vue";

export default {
  data() {
    return {
      toast: false,
      vcash: "",
      cash: "",
      kicon: "",
      consume: "",
      recharge: "",
      TellUser: "",
      limit: "",
      //储值卡密码
      vPwd: ""
    };
  },
  methods: {
    ...mapMutations({
      setWallet: "setG_walletInfo",
      setUserInfo: "setG_UserInfo"
    }),

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1700)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 2000)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end


    init() {
      this.$http.post(api.getMallCoinCanExchange()).then(res => {
        if (!res.Result) {
          this.TellUser = res.Message;
          this.showToast();
          return null;
        } else {
          this.limit = res.Data;
        }
      });
    },
    initAmount() {
      this.vcash = "";
      this.cash = "";
      this.kicon = "";
      this.consume = "";
      this.recharge = "";
    },
    exchange() {
      if (
        this.all == 0 ||
        typeof this.all == "undefined" ||
        this.vcash < 0 ||
        this.cash < 0 ||
        this.kicon < 0 ||
        this.consume < 0 ||
        this.recharge < 0
      ) {
        this.TellUser = "请检查兑换数量!";
        this.showToast();
        return;
      }
      if ((this.consume > 0 || this.recharge > 0) && this.vPwd.trim() == "") {
        this.TellUser = "请输入储值卡密码!";
        this.showToast();
        return;
      }
      var params = new this.URLSearchParam();
      params.append("CardNo", this.g_UserInfo.Card_no);
      params.append("ExpMoneyRemian", this.cash);
      params.append("UnionMoneyRemian", this.vcash);
      params.append("GreenTreeCoin", this.kicon);
      params.append("Storage", this.consume);
      params.append("InvoiceStorage", this.recharge);
      params.append("StoragePassword", this.vPwd);
      params.append("PropertySum", this.all);
      this.$http.post(api.exchangeMallCoin(), params.toParam()).then(res => {
        this.TellUser = "";
        if (res.Data) {
          var i;
          for (i = 0; i < res.Data.length; i++) {
            this.TellUser += res.Data[i].Msg + "<br/>";
            if (res.Data[i].ExchangeResult) {
              this.$http.post(api.GetMyWallet()).then(res => {
                if (res.Result) {
                  //兑换成功更新钱包
                  this.setWallet(res.Data);
                } else {
                  // 兑换失败
                }
              });
            }
          }
          this.showToast();
          //更新可兑换数量
          this.init();
          //更新正在兑换数量
          this.initAmount();
          //更新商城预存款
          this.$http.post(api.SignIn()).then(res => {
            if (res.Result) {
              //this.setUserInfo(res.Data);
            }
          });
        }
        else{
          this.TellUser = res.Message;
          this.showToast();
        }
      });
    }
  },
  created() {
  },
  activated() {
    this.init();
    this.initAmount();
    this.vPwd = "";
  },
  computed: {
    ...mapGetters(["g_walletInfo", "g_UserInfo"]),
    all() {
      return (
        (this.vcash == "" ? 0 : this.vcash) * 1 +
        (this.cash == "" ? 0 : this.cash) * 1 +
        (this.kicon == "" ? 0 : this.kicon) * 0.01 +
        (this.consume == "" ? 0 : this.consume) * 1 +
        (this.recharge == "" ? 0 : this.recharge) * 1
      );
    }
  },
  components: {
    pageTitle
  }
};
</script>


// WEBPACK FOOTER //
// mallDepositExchange.vue?5316ff33